import { createClient } from "../client";
import { Session } from "../utils/session";
import type { AuthResponse } from "../types";

const client = createClient();

export async function loginWithPassword(email: string, password: string): Promise<AuthResponse> {
  const res = await client.post("/v1/auth", {
    type: "email_password_login",
    email,
    password
  });

  if (res.token) {
    Session.set(res.token);
  }

  return res;
}